import React, { useState } from 'react';

import SupplierFrameworkAddSupplierForm from './SupplierFrameworkAddSupplierForm';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function SupplierFrameworkAddSupplierModal(props) {
    const [supplierIsAdded, setSupplierIsAdded] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setSupplierIsAdded(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    const close = () => {
        if (supplierIsAdded || requestFailed) {
            internalSuccessHandler();
        } else {
            internalCloseHandler();
        }
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Add supplier')} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        <div className="modal__form-container">
                            <div className={!supplierIsAdded && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                <SupplierFrameworkAddSupplierForm
                                    saveUrl={props.saveUrl}
                                    internalCloseHandler={internalCloseHandler}
                                    setSupplierIsAdded={setSupplierIsAdded}
                                    request={request}
                                    fetchCommonData={props.fetchCommonData}
                                />
                            </div>
                            <div className={supplierIsAdded ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                <label className="modal__msg modal__text-color">{$t('Supplier added')}</label>
                            </div>
                            <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                <label className="modal__msg modal__error-text-color">{$t('Supplier could not be added')}</label>
                            </div>

                            {(supplierIsAdded || requestFailed) && (
                                <div className="modal__footer">
                                    <Button variant="secondary" onClick={internalSuccessHandler}>
                                        {$t('Close')}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
